import axios from "axios";
import authHeader from '../../../authheader'

const EIRENEWALURL = process.env.REACT_APP_APIURL + "/api/IndividualEiRenewal";

const getViolation = (renewalId) => {
    return axios.get(`${EIRENEWALURL}/violation`, { headers: authHeader(), params: { renewalId } });
}
const postViolation = (data) => {
    return axios.post(`${EIRENEWALURL}/violation`, data, { headers: authHeader() });
}
export default {
    getViolation,
    postViolation
}